// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Debit, {getDefaultState as getDebitDefaultState} from '@deere/cps-it.warranty-model-factory/lib/debit';
import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    claimNumber: t.String,
    debit: Debit,
    debitType: KeyValuePair,
    debitTypes: t.list(KeyValuePair, 'DebitTypes'),
    isConfirmationModalVisible: t.Boolean,
    isFullDebitModalVisible: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        claimNumber: '',
        debit: getDebitDefaultState(),
        debitType: getKeyValueDefaultState(),
        debitTypes: [],
        isConfirmationModalVisible: false,
        isFullDebitModalVisible: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/state/index.js